import { Evento } from '@/types';

export function getSportImage(evento: Evento): string {
  const t = (evento.titolo + ' ' + (evento.altImgEventoSportivo+ ' ' + (evento.descrizioneBreve ?? ''))).toLowerCase();
  if (t.includes('nba') || t.includes('basket')) return '/images/icons/basket.webp';
  if (t.includes('lba') || t.includes('basket')) return '/images/icons/basket.webp';
  if (t.includes('champions') || t.includes('finale') || t.includes('coppa') || t.includes('diretta')) return '/images/icons/tv.webp';
  if (t.includes('derby') || t.includes('milan') || t.includes('inter') || t.includes('serie a') || t.includes('premier') || t.includes('calcio')) return '/images/icons/calcio.webp';
  if (t.includes('summer') || t.includes('estiv') || t.includes('estate')) return '/images/icons/ombrellone.webp';
  if (t.includes('relax')) return '/images/icons/palma.webp';
  if (t.includes('gioch') || t.includes('scatola')) return '/images/icons/joystick.webp';
  return '/images/icons/calcio.webp';
}
